<template>
  <zm-alert
    v-if="showIneligibilityReason"
    type="warning"
    show-icon
    :closable="false"
    class="opc-cart__referral_discount_alert"
  >
    <div>
      {{ ineligibilityMessage }}
      <zm-button v-if="showSwitchBack" type="link" class="opc-cart__referral_discount_alert-switch-back" @click="handleSwitchBack">
        {{ $t('billing.referral.switch_back_to_workplace_pro') }}
      </zm-button>
    </div>
  </zm-alert>
</template>

<script>
import { mapGetters } from 'vuex';
import { REFERRAL_INELIGIBILITY_REASON } from '@/store/modules/refer-a-friend';
import { OPC_CONSTANT_PATH } from '@/common/constants';

export default {
  computed: {
    ...mapGetters([
      'referAFriendIneligibilityReason',
    ]),
    showIneligibilityReason() {
      return this.referAFriendIneligibilityReason;
    },
    showSwitchBack() {
      return this.referAFriendIneligibilityReason === REFERRAL_INELIGIBILITY_REASON.PLAN_NOT_SUPPORTED;
    },
    ineligibilityMessage() {
      if (this.referAFriendIneligibilityReason === REFERRAL_INELIGIBILITY_REASON.PLAN_NOT_SUPPORTED) {
        return this.$t('billing.referral.plan_not_supported');
      }
      if (this.referAFriendIneligibilityReason === REFERRAL_INELIGIBILITY_REASON.FREE_TRIAL_NOT_SUPPORTED) {
        return this.$t('billing.referral.free_trial_not_supported');
      }
      return '';
    },
  },
  methods: {
    handleSwitchBack() {
      window.location.href = OPC_CONSTANT_PATH.basic2pro;
    },
  },
};
</script>

<style lang="scss">
.opc-cart__referral_discount_alert {
  font-style: normal;
  line-height: 18px;
  margin-bottom: 24px;

  &-switch-back {
    &.zm-button--link {
      display: block;
      padding: 0;
      margin-top: 8px;
      font-size: inherit;
      line-height: inherit;
    }
  }
}
</style>

